import { Arbeitszeit } from '../../../../entities';
import { t } from 'i18next';
import { useArbeitszeitDelete } from '../../../../hooks/useArbeitszeitenDelete';
import { handleOnCompletedDelete } from '../../handleOnCompletedDelete';
import { ConfirmDeletePopover } from '../../../Popover/ConfirmDeletePopover';
import { toast } from '@/hooks/use-toast';
import * as Sentry from '@sentry/react';
import { useNavigate, useParams } from 'react-router-dom';

export function DeleteArbeitszeit({
  arbeitszeit,
  onDeleted,
}: {
  arbeitszeit: Arbeitszeit;
  isDeleting: boolean;
  onDeleted?: () => void;
}) {
  const [arbeitszeitDelete] = useArbeitszeitDelete();
  const { year, month, day } = useParams();
  const navigate = useNavigate();

  async function handleDelete() {
    try {
      const result = await arbeitszeitDelete({
        arbeitszeitId: arbeitszeit.id,
      });
      if (result.data) {
        handleOnCompletedDelete(result.data, t);
      }
      navigate(`/arbeitszeiten/uebersicht/${year}/${month}/${day}`);
    } catch (e) {
      toast({
        variant: 'destructive',
        title: t(
          'domain.arbeitszeiten.sheet.header.arbeitszeitDeleteUnknownError',
        ),
      });
      Sentry.captureException(e);
    }
  }

  return (
    <ConfirmDeletePopover
      confirmText={t('domain.arbeitszeiten.sheet.arbeitszeit.confirmDelete')}
      handleDelete={handleDelete}
      onDeleted={onDeleted}
      confirmButtonText={t(
        'domain.arbeitszeiten.sheet.arbeitszeit.confirmButton',
      )}
      processingButtonText={t(
        'domain.arbeitszeiten.sheet.arbeitszeit.confirmIsDeleting',
      )}
    />
  );
}
